import { render } from "./Order.vue?vue&type=template&id=adb5afa8&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=adb5afa8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adb5afa8"],['__file',"src/views/index/components/Order.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "adb5afa8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('adb5afa8', __exports__)) {
    console.log('reload')
    api.reload('adb5afa8', __exports__)
  }
  
  module.hot.accept("./Order.vue?vue&type=template&id=adb5afa8&scoped=true", () => {
    console.log('re-render')
    api.rerender('adb5afa8', render)
  })

}


export default __exports__